import React, { useState, useEffect } from "react";
import Listing from "./Listing";
import YTPurchase from "./YTPurchase";
import Referral from "./Referral";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";

export default function YTChecklists({ setProvince }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  useEffect(() => {
    setProvince("YT");
  });

  const [TransactionType, setTransactionType] = useState("");

  const handleTransactionType = (e) => {
    setTransactionType(e.target.value);
  };

  return (
    <div className="flex flex-col w-full pt-5">
      <strong className="text-red-500 pl-5">
        ***This Section Is Under Development***
      </strong>
      <div className="flex items-center w-full pb-5">
        <ThemeProvider theme={theme}>
          <FormControl sx={{ mt: 2, ml: 2, minWidth: 325, maxWidth: 110 }}>
            <InputLabel size="small" className="select-default-label">
              Transaction Type
            </InputLabel>
            <Select
              value={TransactionType}
              name="Transaction Type"
              label="Transaction Type"
              onChange={handleTransactionType}
              size="small"
              sx={{ borderRadius: 20 }}
            >
              <MenuItem key={Math.random()} value="Listing">
                Listing
              </MenuItem>
              <MenuItem key={Math.random()} value="Purchase">
                Purchase
              </MenuItem>

              <MenuItem key={Math.random()} value="Referral">
                Referral
              </MenuItem>
            </Select>
          </FormControl>
        </ThemeProvider>
      </div>
      {TransactionType === "Listing" ? <Listing /> : ""}
      {TransactionType === "Purchase" ? <YTPurchase /> : ""}
      {TransactionType === "Referral" ? <Referral /> : ""}
      {TransactionType === "" ? (
        <>
          <p className="pl-4">
            Select the side of the transaction you are currently dealing with.
            <br />
            <br />
            <strong>Example: </strong>If you already have a Listing and are
            dealing with a Buyer for that Listing, choose "Purchase".
          </p>
        </>
      ) : (
        ""
      )}
    </div>
  );
}
